import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  Configurations,
  DataService,
  FgMenuService,
  LocalStorageService,
  SidenavComponent,
} from "fg-library";
import { LayoutService } from "../main-nav/layoutservice";
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-client-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  standalone: false,
})
export class ClientSidenavComponent extends SidenavComponent implements OnInit {

  AppPreference: any = {};
  showMe: boolean = false;

  constructor(
    public router: Router,
    public fgMenuService: FgMenuService,
    public route: ActivatedRoute,
    public dataService: DataService,
    public config: Configurations,
    private localStorage: LocalStorageService,
    private layoutService: LayoutService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    super(router, fgMenuService, route, dataService, config);
  }

  ngOnInit(): void {
    this.currentApp = this.fgMenuService.fgCurrentApplication;
    this.layoutService.layout$.subscribe((layout) => {
      this.setLayout(layout);
    });

    if (isPlatformBrowser(this.platformId)) {
      const pref = this.localStorage.get("AppPreference");
      this.AppPreference = pref
        ? JSON.parse(pref)
        : { theme: 'tradeportal-theme', layout: 'HORIZONTAL' };
      this.setLayout(this.AppPreference.layout);
    }
  }

  public toggleActive(menu: any, index: number): void {
    if (this.AppPreference?.layout === 'VERTICAL') {
      this.layoutService.setSidenavPersistence(true);
      this.fgMenuService.toggleSideNav(true);
    }
    super.toggleActive(menu, index);
  }

  setLayout(layout: string) {
    this.showMe = layout === 'VERTICAL';
    this.AppPreference.layout = layout;
  }

  extractFirstLetters(displayValue: any): string {
    if (displayValue && displayValue.includes(" ")) {
      let words = displayValue.split(" ");
      return words[0].charAt(0) + words[words.length - 1].charAt(0);
    } else if (displayValue) {
      return displayValue.charAt(0);
    }
    return '';
  }
}